"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentAuditLog_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AppointmentAuditLog_Factory = /** @class */ (function () {
    function AppointmentAuditLog_Factory() {
    }
    AppointmentAuditLog_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AppointmentActionStatusCode: model.AppointmentActionStatusCode,
            AppointmentAuditDescription: model.AppointmentAuditDescription,
            AppointmentId: model.AppointmentId,
            AuditDateTime: Date_Factory_1.Date_Factory.CreateIncoming(model.AuditDateTime),
            NewStatusCode: model.NewStatusCode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SeatingLocationId: model.SeatingLocationId,
            UserId: model.UserId,
        };
        return result;
    };
    AppointmentAuditLog_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AppointmentActionStatusCode: model.AppointmentActionStatusCode,
            AppointmentAuditDescription: model.AppointmentAuditDescription,
            AppointmentId: model.AppointmentId,
            AuditDateTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.AuditDateTime),
            NewStatusCode: model.NewStatusCode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SeatingLocationId: model.SeatingLocationId,
            UserId: model.UserId,
        };
        return result;
    };
    return AppointmentAuditLog_Factory;
}());
exports.AppointmentAuditLog_Factory = AppointmentAuditLog_Factory;
